module.exports = __webpack_public_path__ + "img/doc.74c0123e.svg";